import { useState } from "react";

import { Button } from "@icg360/design-system";

import { PaperlessModal } from "components/paperless-modal";
import { type PolicyDetail } from "utils";

type EnrollPaperlessProps = {
  userDetails?: PolicyDetail["userDetails"];
  userBilling?: PolicyDetail["userBilling"];
  isEnrolledDocuments: boolean;
  isEnrolledBilling: boolean;
  policyId: string;
};

const EnrollPaperless = ({
  isEnrolledDocuments,
  isEnrolledBilling,
  userDetails,
  userBilling,
  policyId,
}: EnrollPaperlessProps) => {
  const [showPaperlessModal, setShowPaperlessModal] = useState(false);

  const { insuredPreferences } = userDetails ?? {};

  return (
    <>
      {(!isEnrolledDocuments || !isEnrolledBilling) && (
        <Button
          appearance="secondary"
          leadingIcon="Paperless"
          onPress={() => setShowPaperlessModal(true)}
          data-testid="enroll-paperless-btn"
        >
          Enroll in paperless
        </Button>
      )}
      {(!isEnrolledBilling || !isEnrolledDocuments) && (
        <PaperlessModal
          show={showPaperlessModal}
          onClose={() => setShowPaperlessModal(false)}
          documentsEmailAddress={
            insuredPreferences?.opInsuredEmailAddressDocuments ||
            insuredPreferences?.opInsuredEmailAddress
          }
          userDetails={userDetails}
          userBilling={userBilling}
          policyId={policyId}
        />
      )}
    </>
  );
};

export default EnrollPaperless;
